import React, { useContext } from 'react';
import Helmet from 'react-helmet';

import { NotificationsContext } from 'client/components/NotificationsContext';
import { UserContext } from 'client/components/UserContext';

const NotificationsTitleUpdater = () => {
  const { userId } = useContext(UserContext);
  const { notifications } = useContext(NotificationsContext);
  const count = notifications && notifications.length;
  const loggedIn = !!userId;

  return <Helmet titleTemplate={loggedIn && count ? `(${count}) %s` : '%s'} />;
};

export default NotificationsTitleUpdater;
